import { useReducedMotion } from "framer-motion";

function LogoCell({ org, compact }) {
  const pad = compact
    ? "px-4 sm:px-5"
    : "px-8 sm:px-10 md:px-14";
  return (
    <div
      className={`flex h-[52px] shrink-0 items-center justify-center sm:h-[56px] ${pad}`}
    >
      {org.logo ? (
        <img
          src={org.logo}
          alt=""
          role="presentation"
          className="max-h-[38px] w-auto max-w-[min(200px,28vw)] object-contain opacity-[0.52] grayscale md:max-h-[46px] md:max-w-[220px]"
          loading="lazy"
        />
      ) : (
        <span className="whitespace-nowrap text-[12px] font-bold uppercase tracking-[0.14em] text-shark-400 md:text-[13px]">
          {org.name}
        </span>
      )}
    </div>
  );
}

/**
 * Full-bleed infinite logo row (OP-style “Our clients”: slow drift, generous spacing, larger marks).
 */
function TrustedClientsMarquee({ organizations }) {
  const reduceMotion = useReducedMotion();
  const loop = [...organizations, ...organizations, ...organizations];

  if (reduceMotion) {
    return (
      <div className="mt-12 w-full px-4 lg:mt-14">
        <div className="mx-auto flex max-w-[1280px] flex-wrap items-center justify-center gap-y-4 py-6 md:py-8">
          {organizations.map((org) => (
            <LogoCell key={org.name} org={org} compact />
          ))}
        </div>
      </div>
    );
  }

  return (
    <div className="relative mt-12 w-full min-w-0 lg:mt-14">
      <div
        className="isolate overflow-hidden py-6 md:py-8"
        style={{
          maskImage:
            "linear-gradient(90deg, transparent 0%, #000 10%, #000 90%, transparent 100%)",
          WebkitMaskImage:
            "linear-gradient(90deg, transparent 0%, #000 10%, #000 90%, transparent 100%)",
        }}
      >
        <div className="flex w-max flex-nowrap animate-clients-marquee items-center">
          {loop.map((org, i) => (
            <LogoCell key={`${org.name}-${i}`} org={org} compact={false} />
          ))}
        </div>
      </div>
    </div>
  );
}

export default TrustedClientsMarquee;
